import React from "react";
import "./Skeleton.css";

/**
 * Reusable shimmering skeleton placeholder.
 *
 * Props:
 *  - type:         variant modifier ("text" | "title" | "button" | "card" | "image" | "circle")
 *  - width/height: CSS size value (number = px, or string)
 *  - borderRadius: CSS border radius value
 *  - style:        additional inline styles
 *  - className:    extra classes for section-specific layouts
 */
export default function Skeleton({
  type = "text",
  width = "100%",
  height = "1em",
  borderRadius,
  style,
  className = "",
}) {
  return (
    <div
      className={`skeleton skeleton--${type} ${className}`}
      style={{ width, height, borderRadius, ...style }}
      aria-hidden="true"
    />
  );
}